/*
 * Kala dive page (layout/kala-dive.liquid). Ported from site/mockup-c, iteration 2.
 *
 * The sea is painted into the page and scrolls natively: the water is a CSS gradient, the rock is
 * static SVG chunks, and only the fish move, in canvases that exist near the viewport and animate
 * by time, never by scroll position. The cart is Shopify's own (AJAX Cart API).
 * Everything sits in init(), which returns a teardown so the theme editor can re-run it after a
 * section re-renders.
 */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp01 = v => Math.max(0, Math.min(1, v));
  const smoothstep = (a, b, x) => { const t = clamp01((x - a) / (b - a)); return t * t * (3 - 2 * t); };
  const pageY = el => el.getBoundingClientRect().top + scrollY;

  function init() {
    const ac = new AbortController();
    const on = (target, type, fn, opts = {}) => target && target.addEventListener(type, fn, { ...opts, signal: ac.signal });
    const observers = [];
    const watch = o => { observers.push(o); return o; };
    const timers = new Set();
    let raf = 0, surfacing = 0;

    let cfg = {};
    try { cfg = JSON.parse($('#kalaDiveConfig')?.textContent || '{}'); } catch (e) { cfg = {}; }
    const PRICE = { sub: Number(cfg.priceSub) || 49, once: Number(cfg.priceOnce) || 59 };
    const FREE = Number(cfg.freeShipping) || 60;
    const SACHETS = Number(cfg.sachets) || 28;
    const state = { plan: cfg.hasPlan === false ? 'once' : 'sub', qty: 1 };
    const money = n => '$' + (Number.isInteger(n) ? n : n.toFixed(2));
    const bags = n => n === 1 ? (cfg.bag1 || '1 bag') : n === 2 ? (cfg.bag2 || '2 bags') : n + ' bags';

    /* ---------- Gallery ---------- */
    const track = $('#track');
    if (track) {
      const slides = $$('.g-slide', track);
      const thumbs = $('#thumbs');
      let index = 0;
      thumbs.innerHTML = '';
      const go = i => track.scrollTo({ left: i * track.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
      slides.forEach((s, i) => {
        const b = document.createElement('button');
        b.className = 'g-thumb' + (s.classList.contains('g-slide--pack') ? ' is-pack' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show image ' + (i + 1));
        const t = s.dataset.thumb;
        b.innerHTML = t === 'info' ? '<span class="mini" aria-hidden="true"><span class="mini__in">' + s.innerHTML + '</span></span>' : '<img alt="" src="' + t + '">';
        b.addEventListener('click', () => go(i));
        thumbs.appendChild(b);
      });
      const setIndex = i => {
        index = i;
        [...thumbs.children].forEach((t, j) => t.setAttribute('aria-current', String(j === i)));
        $('#prev').disabled = i === 0;
        $('#next').disabled = i === slides.length - 1;
        $('#gCount').textContent = (i + 1) + ' / ' + slides.length;
      };
      const gio = watch(new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) setIndex(slides.indexOf(e.target)); }), { root: track, threshold: 0.6 }));
      slides.forEach(s => gio.observe(s));
      on($('#prev'), 'click', () => go(Math.max(0, index - 1)));
      on($('#next'), 'click', () => go(Math.min(slides.length - 1, index + 1)));
      if (slides.length) setIndex(0);
    }

    /* ---------- Buy box ---------- */
    const setText = (sel, text) => $$(sel).forEach(el => { el.textContent = text; });
    const render = () => {
      const per = PRICE[state.plan], total = per * state.qty, was = PRICE.once * state.qty;
      $$('[data-plan]').forEach(o => o.setAttribute('aria-checked', String(o.dataset.plan === state.plan)));
      $$('[data-qty]').forEach(o => o.setAttribute('aria-checked', String(Number(o.dataset.qty) === state.qty)));
      setText('#qtyEcho', bags(state.qty));
      setText('#planEcho', state.plan === 'sub' ? cfg.subName : cfg.onceName);
      setText('[data-perday]', money(Math.round(per / SACHETS * 100) / 100) + '/day');
      $$('[data-was]').forEach(el => { el.textContent = money(was); el.hidden = state.plan === 'once'; });
      setText('[data-now]', money(total));
      setText('[data-was2]', money(was));
      setText('[data-now2]', money(PRICE.sub * state.qty));
      setText('[data-once], [data-once2]', money(PRICE.once * state.qty));
      setText('[data-bagline]', (cfg.productTitle || 'Daily Catch') + ', ' + bags(state.qty));
      setText('[data-bagsub]', (SACHETS * state.qty) + ' sachets');
      const freeShip = PRICE.sub * state.qty >= FREE;
      setText('[data-shipsub]', freeShip ? cfg.shipFree : cfg.shipNotYet);
      setText('[data-shipr]', freeShip ? 'FREE' : 'At checkout');
      setText('#atcPrice', money(total));
      setText('[data-surface-price]', money(total));
      setText('#ddPlan [data-dd-label]', state.plan === 'sub' ? cfg.subName : cfg.onceName);
      setText('#ddQty [data-dd-label]', bags(state.qty));
    };
    $$('.plan').forEach(o => on(o, 'click', () => { state.plan = o.dataset.plan; render(); }));
    $$('.size').forEach(o => on(o, 'click', () => { state.qty = Number(o.dataset.qty); render(); }));
    render();

    /* ---------- Loops: play while on screen, tap a question for its answer ---------- */
    const reels = $('#reels');
    if (reels) {
      const vids = $$('video', reels);
      watch(new IntersectionObserver(([e]) => vids.forEach(v => { if (e.isIntersecting && !reduce.matches) v.play().catch(() => {}); else v.pause(); }), { threshold: 0.3 })).observe(reels);
      $$('.reel', reels).forEach(r => on(r, 'click', () => r.setAttribute('aria-expanded', String(r.getAttribute('aria-expanded') !== 'true'))));
      const reelStep = () => (reels.querySelector('.reel')?.getBoundingClientRect().width || 200) + 10;
      on($('#rPrev'), 'click', () => reels.scrollBy({ left: -reelStep(), behavior: 'smooth' }));
      on($('#rNext'), 'click', () => reels.scrollBy({ left: reelStep(), behavior: 'smooth' }));
      on(reels, 'scroll', () => {
        $('#rPrev').disabled = reels.scrollLeft < 4;
        $('#rNext').disabled = reels.scrollLeft > reels.scrollWidth - reels.clientWidth - 4;
      }, { passive: true });
    }
    const keyVid = $('.keys__media video');
    if (keyVid) watch(new IntersectionObserver(([e]) => { if (e.isIntersecting && !reduce.matches) keyVid.play().catch(() => {}); else keyVid.pause(); }, { threshold: 0.2 })).observe(keyVid);

    /* ---------- What omega-3 does ---------- */
    let prevNode = $('.node');
    $$('.node').forEach(n => on(n, 'click', () => {
      $$('.node').forEach(x => { x.setAttribute('aria-pressed', String(x === n)); x.classList.remove('was'); });
      if (prevNode && prevNode !== n) prevNode.classList.add('was');
      prevNode = n;
      const label = $('#stepLabel');
      label.textContent = '';
      const b = document.createElement('b');
      b.textContent = n.dataset.name;
      label.append(b, n.dataset.sub);
      $('#stepDesc').textContent = n.dataset.desc;
    }));

    /* ---------- Sticky bar: checked on scroll, since a jump link can skip past the button ---------- */
    const sticky = $('#sticky'), atcBtn = $('#atc');
    let stickyOn = null;
    const updateSticky = () => {
      if (!sticky || !atcBtn) return;
      const show = atcBtn.getBoundingClientRect().bottom < 0;
      if (show === stickyOn) return;
      stickyOn = show;
      sticky.classList.toggle('is-shown', show);
      sticky.setAttribute('aria-hidden', String(!show));
      $$('#stickyAtc, .dd > button').forEach(b => { b.tabIndex = show ? 0 : -1; });
      if (!show) $$('.dd').forEach(d => d.classList.remove('is-open'));
    };
    updateSticky();
    $$('.dd').forEach(d => {
      const btn = $(':scope > button', d);
      on(btn, 'click', () => {
        const open = !d.classList.contains('is-open');
        $$('.dd').forEach(x => { x.classList.remove('is-open'); $(':scope > button', x).setAttribute('aria-expanded', 'false'); });
        d.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
      $$('.dd__menu button', d).forEach(o => on(o, 'click', () => {
        if (o.dataset.plan) state.plan = o.dataset.plan;
        if (o.dataset.qty) state.qty = Number(o.dataset.qty);
        render();
        d.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }));
    });

    /* ---------- Drawers and sheets ---------- */
    const scrim = $('#scrim');
    let lastFocus = null;
    const closeAll = keepFocus => {
      $$('.drawer.is-open, .sheet.is-open').forEach(d => d.classList.remove('is-open'));
      $$('[aria-controls]').forEach(b => b.setAttribute('aria-expanded', 'false'));
      scrim?.classList.remove('is-open');
      document.body.style.overflow = '';
      if (!keepFocus) lastFocus?.focus?.({ preventScroll: true });
    };
    const open = (el, trigger) => {
      if (!el) return;
      closeAll(true);
      lastFocus = trigger || document.activeElement;
      el.classList.add('is-open');
      scrim?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      trigger?.setAttribute?.('aria-expanded', 'true');
      const t = setTimeout(() => $('[data-close]', el)?.focus({ preventScroll: true }), 60);
      timers.add(t);
    };
    on(scrim, 'click', () => closeAll());
    on(document, 'keydown', e => { if (e.key === 'Escape') closeAll(); });
    $$('[data-close]').forEach(b => on(b, 'click', () => { closeAll(); if (b.dataset.go) location.hash = b.dataset.go; }));
    $$('[data-open]').forEach(b => on(b, 'click', e => open($('#' + b.dataset.open), e.currentTarget)));
    on($('#menuBtn'), 'click', e => open($('#menu'), e.currentTarget));

    /* ---------- Cart: Shopify's own, through the AJAX Cart API ---------- */
    let cart = null;
    const fmt = cents => {
      const v = cents / 100;
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (cart && cart.currency) || 'USD', minimumFractionDigits: Number.isInteger(v) ? 0 : 2 }).format(v); }
      catch (e) { return money(v); }
    };
    const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    const renderCart = () => {
      const items = cart ? cart.items : [];
      const has = items.length > 0;
      const lines = $('#lines');
      if (lines) {
        lines.innerHTML = items.map(it => {
          const plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : 'One-time purchase';
          const was = it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '';
          const img = it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=160' : '';
          return '<div class="line" data-key="' + esc(it.key) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
            '<div><h3>' + esc(it.product_title) + '</h3><p>' + esc(plan) + '</p><div class="qty"><button type="button" data-step="-1" aria-label="Remove one"' + (it.quantity <= 1 ? ' disabled' : '') + '><svg class="i"><use href="#i-minus"/></svg></button><output>' + it.quantity + '</output><button type="button" data-step="1" aria-label="Add one"><svg class="i"><use href="#i-plus"/></svg></button></div></div>' +
            '<p class="line__price">' + was + '<span>' + fmt(it.final_line_price) + '</span></p></div>';
        }).join('');
      }
      const total = cart ? cart.total_price : 0;
      const empty = $('#emptyNote');
      if (empty) empty.hidden = has;
      const sub = $('#subtotal');
      if (sub) sub.textContent = fmt(total);
      const checkout = $('#checkout');
      if (checkout) checkout.disabled = !has;
      const left = Math.max(0, FREE * 100 - total);
      const ship = $('#shipMsg');
      if (ship) ship.textContent = !has ? 'Free shipping on orders $' + FREE + '+' : left > 0 ? 'Spend ' + fmt(left) + ' more for free shipping' : 'Free shipping applied';
      requestAnimationFrame(() => { const f = $('#shipFill'); if (f) f.style.width = Math.min(100, total / (FREE * 100) * 100) + '%'; });
      const count = $('#count');
      if (count) { count.hidden = !cart || cart.item_count === 0; count.textContent = cart ? cart.item_count : 0; }
    };
    const loadCart = async () => {
      try { const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); cart = await r.json(); } catch (e) { cart = null; }
      renderCart();
    };
    on($('#lines'), 'click', async e => {
      const b = e.target.closest('[data-step]');
      if (!b) return;
      const line = b.closest('.line');
      const item = cart && cart.items.find(i => i.key === line.dataset.key);
      if (!item) return;
      b.disabled = true;
      try {
        const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: Math.max(0, Math.min(10, item.quantity + Number(b.dataset.step))) }) });
        cart = await r.json();
      } catch (err) { /* keep the last cart */ }
      renderCart();
    });
    const addToCart = async (trigger, surfaced = false) => {
      const item = { id: cfg.variantId, quantity: state.qty };
      const wantsPlan = state.plan === 'sub';
      if (wantsPlan && cfg.sellingPlanId) item.selling_plan = cfg.sellingPlanId;
      const note = $('#checkoutNote');
      try {
        if (!cfg.variantId) throw new Error('No product variant');
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Could not add to cart');
        await loadCart();
        const planNote = $('#planNote');
        if (planNote) planNote.hidden = !(wantsPlan && !cfg.sellingPlanId);
      } catch (err) {
        if (note) note.textContent = err.message || 'Could not add to cart. Try again.';
      }
      const s = $('#surfaced');
      if (s) s.hidden = !surfaced;
      open($('#cart'), trigger);
    };
    on(atcBtn, 'click', e => addToCart(e.currentTarget));
    on($('#stickyAtc'), 'click', e => addToCart(e.currentTarget));
    on($('#cartBtn'), 'click', e => { const s = $('#surfaced'); if (s) s.hidden = true; loadCart(); open($('#cart'), e.currentTarget); });
    on($('#checkout'), 'click', () => { location.href = root + 'checkout'; });
    loadCart();

    /* ---------- 2-question check ---------- */
    const ans = {};
    $$('#quiz [data-q]').forEach(b => on(b, 'click', () => {
      ans[b.dataset.q] = b.dataset.a;
      if (b.dataset.q === '1') delete ans[2];
      $$('#quiz [data-q]').forEach(x => x.setAttribute('aria-pressed', String(ans[x.dataset.q] === x.dataset.a)));
      $('#q2').hidden = ans[1] !== 'yes';
      const yes = ans[1] === 'no' || (ans[1] === 'yes' && ans[2] === 'no');
      $('#resYes').hidden = !yes;
      $('#resNo').hidden = !(ans[1] === 'yes' && ans[2] === 'yes');
    }));

    /* =========================================================================================
       The sea.
       ========================================================================================= */
    const sea = $('#sea'), seaBg = $('#seaBg');
    const SEA = [[0, [17, 79, 170]], [0.1, [22, 57, 161]], [0.32, [23, 54, 135]], [0.56, [25, 50, 110]], [0.8, [26, 45, 88]], [1, [27, 41, 72]]];
    const INK = [27, 38, 59];
    const seaAt = d => {
      d = clamp01(d);
      for (let i = 1; i < SEA.length; i++) if (d <= SEA[i][0]) { const [d0, c0] = SEA[i - 1], [d1, c1] = SEA[i]; const k = (d - d0) / (d1 - d0); return c0.map((v, j) => v + (c1[j] - v) * k); }
      return SEA[SEA.length - 1][1];
    };
    const toward = (c, t, k) => c.map((v, j) => v + (t[j] - v) * k);
    const rgb = c => 'rgb(' + (c[0] | 0) + ' ' + (c[1] | 0) + ' ' + (c[2] | 0) + ')';
    const rgba = (c, a) => 'rgba(' + (c[0] | 0) + ',' + (c[1] | 0) + ',' + (c[2] | 0) + ',' + a + ')';
    const hash = k => { const s = Math.sin(k * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); };
    const swell = y => Math.sin(y * 0.0021 + 1.3) * 0.5 + Math.sin(y * 0.0057 + 4.1) * 0.3 + Math.sin(y * 0.013 + 2.2) * 0.2;
    const DPR = Math.min(devicePixelRatio || 1, 2);
    const BAND = 800, PAD = 150, STEP = 16;
    let W = 0, SH = 0, seaTop = 0;
    let bands = [];

    const kick = () => { if (!raf && sea) raf = requestAnimationFrame(frame); };

    if (sea) {
      /* Waterline: two seamless wave tiles sliding at different speeds */
      const waveTile = (w, fill, foam) => 'url("data:image/svg+xml,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="48" viewBox="0 0 ' + w + ' 48"><path d="M0 26 C ' + (w / 6) + ' 18, ' + (w / 3) + ' 18, ' + (w / 2) + ' 26 S ' + (w * 5 / 6) + ' 34, ' + w + ' 26 V48 H0 Z" fill="' + fill + '"/>' +
        (foam ? '<path d="M0 26 C ' + (w / 6) + ' 18, ' + (w / 3) + ' 18, ' + (w / 2) + ' 26 S ' + (w * 5 / 6) + ' 34, ' + w + ' 26" fill="none" stroke="' + foam + '" stroke-width="1.6"/>' : '') + '</svg>') + '")';
      $('.wave--back', sea).style.backgroundImage = waveTile(260, '#3A70C4', '');
      $('.wave--front', sea).style.backgroundImage = waveTile(320, '#114FAA', 'rgba(255,255,255,0.85)');
    }

    /* Rock: static SVG chunks */
    const reach = () => (W >= 990 ? Math.min(190, W * 0.12) : Math.min(52, W * 0.135));
    const wallAt = (side, y, scale) => {
      const env = smoothstep(0.1, 0.48, y / SH);
      if (env <= 0) return 0;
      const k = Math.round(y / STEP) + (side < 0 ? 0 : 7919) + scale * 131;
      return Math.max(0, reach() * scale * env * (0.7 + 0.3 * swell(y * 1.3 + k)) + (hash(k) - 0.5) * 14 * env);
    };
    const floorY = x => SH - 170 + 24 * swell(x * 1.7 + 40) + (hash(Math.round(x / 24) + 5) - 0.5) * 16;
    const rockSVG = (k, layer) => {
      const y0 = k * BAND, y1 = Math.min(SH, y0 + BAND), h = y1 - y0;
      const far = layer === 'far';
      const scale = far ? 1.45 : 1, dark = far ? 0.3 : 0.64;
      const id = layer + k;
      let defs = '<linearGradient id="g' + id + '" x1="0" y1="0" x2="0" y2="' + h + '" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="' + rgb(toward(seaAt(y0 / SH), INK, dark)) + '"/><stop offset="1" stop-color="' + rgb(toward(seaAt(y1 / SH), INK, dark)) + '"/></linearGradient>';
      let body = '';
      for (const side of [-1, 1]) {
        const edge = side < 0 ? 0 : W;
        const pts = [];
        let any = false;
        for (let y = Math.floor(y0 / STEP) * STEP - STEP; y <= y1 + STEP; y += STEP) {
          const w = wallAt(side, y, scale);
          if (w > 0.5) any = true;
          pts.push([side < 0 ? w : W - w, y - y0, y]);
        }
        if (!any) continue;
        const first = pts[0][1], last = pts[pts.length - 1][1];
        body += '<path d="M' + edge + ' ' + first + pts.map(p => 'L' + p[0].toFixed(1) + ' ' + p[1]).join('') + 'L' + edge + ' ' + last + 'Z" fill="url(#g' + id + ')"/>';
        if (far) continue;
        body += '<path d="M' + edge + ' ' + first + pts.map(p => { const w = Math.abs(p[0] - edge) * (0.5 + 0.18 * swell(p[2] * 0.9 + side * 50)); return 'L' + (side < 0 ? w : W - w).toFixed(1) + ' ' + p[1]; }).join('') + 'L' + edge + ' ' + last + 'Z" fill="rgb(6 10 22 / 0.3)"/>';
        let cracks = '';
        pts.forEach((p, i) => {
          if (i % 3) return;
          const kk = p[2] / STEP + (side < 0 ? 0 : 31);
          const w = Math.abs(p[0] - edge);
          if (w < 12 || hash(kk * 2.3) < 0.5) return;
          let x = side < 0 ? w * (0.2 + 0.55 * hash(kk * 4.9)) : W - w * (0.2 + 0.55 * hash(kk * 4.9));
          let y = p[1];
          cracks += 'M' + x.toFixed(1) + ' ' + y;
          const segs = 3 + Math.floor(hash(kk * 6.1) * 3);
          for (let j = 0; j < segs; j++) { x += (hash(kk * 8.3 + j * 1.7) - 0.5) * 12; y += 5 + hash(kk * 9.1 + j * 2.9) * 10; cracks += 'L' + x.toFixed(1) + ' ' + y.toFixed(1); }
        });
        if (cracks) body += '<path d="' + cracks + '" fill="none" stroke="rgb(4 8 18 / 0.6)" stroke-width="1"/>';
        body += '<path d="' + pts.map((p, i) => (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1]).join('') + '" fill="none" stroke="rgb(253 245 228 / 0.07)" stroke-width="1"/>';
      }
      if (far && y1 / SH > 0.38) {
        const a0 = smoothstep(0.38, 0.95, y0 / SH), a1 = smoothstep(0.38, 0.95, y1 / SH);
        defs += '<pattern id="p' + id + '" width="6" height="6" patternUnits="userSpaceOnUse"><rect width="1" height="1" fill="rgb(253 245 228 / 0.06)"/><rect x="3" y="3" width="1" height="1" fill="rgb(253 245 228 / 0.06)"/></pattern><linearGradient id="a' + id + '" x1="0" y1="0" x2="0" y2="' + h + '" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" stop-opacity="' + a0.toFixed(3) + '"/><stop offset="1" stop-color="#fff" stop-opacity="' + a1.toFixed(3) + '"/></linearGradient><mask id="m' + id + '"><rect width="' + W + '" height="' + h + '" fill="url(#a' + id + ')"/></mask>';
        body = '<rect width="' + W + '" height="' + h + '" fill="url(#p' + id + ')" mask="url(#m' + id + ')"/>' + body;
      }
      if (!far && y1 > SH - 230) {
        let d = 'M0 ' + h;
        for (let x = 0; x <= W + 24; x += 24) d += 'L' + x + ' ' + (floorY(x) - y0).toFixed(1);
        d += 'L' + W + ' ' + h + 'Z';
        body += '<path d="' + d + '" fill="' + rgb(toward(SEA[SEA.length - 1][1], [12, 18, 32], 0.6)) + '"/>';
        let top = '';
        for (let x = 0; x <= W + 24; x += 24) top += (x ? 'L' : 'M') + x + ' ' + (floorY(x) - y0).toFixed(1);
        body += '<path d="' + top + '" fill="none" stroke="rgb(253 245 228 / 0.08)" stroke-width="1"/>';
      }
      if (!body) return '';
      return '<svg class="rock rock--' + layer + '" style="top:' + y0 + 'px;height:' + h + 'px" width="' + W + '" height="' + h + '" viewBox="0 0 ' + W + ' ' + h + '" preserveAspectRatio="none"><defs>' + defs + '</defs>' + body + '</svg>';
    };
    const flecksFor = k => {
      const y0 = k * BAND, y1 = Math.min(SH, y0 + BAND);
      let html = '';
      for (const side of [-1, 1]) {
        for (let y = Math.floor(y0 / STEP) * STEP; y < y1; y += STEP) {
          const kk = y / STEP + (side < 0 ? 0 : 7919);
          if (y / SH < 0.55 || hash(kk * 3.1) < 0.9) continue;
          const w = wallAt(side, y, 1);
          if (w < 18) continue;
          const inset = 6 + hash(kk * 5.7) * (w - 14);
          html += '<i class="fleck" style="top:' + y + 'px;left:' + (side < 0 ? inset : W - inset).toFixed(1) + 'px;animation-delay:-' + (hash(kk * 7.3) * 3.2).toFixed(2) + 's"></i>';
        }
      }
      return html;
    };

    /* ---------- Fish: sprites drawn once, then blitted ---------- */
    // Each species is drawn side-on, heading right, in a 64×32 unit box with the fish 56 units long.
    // Frames step through the tail beat; a second row is the same fish catching the light.
    const FRAMES = 8;
    const fishPath = (g, ph, o) => {
      const L = 56, cx = 32, cy = 16, deep = o.deep, tail = o.tail;
      const open = 0.8 + 0.2 * Math.cos(ph), shift = 1.6 * Math.sin(ph);
      g.beginPath();
      g.moveTo(cx + 0.5 * L, cy + 0.5);
      g.bezierCurveTo(cx + 0.36 * L, cy - deep * L, cx - 0.04 * L, cy - deep * L * 1.04, cx - 0.33 * L, cy - 0.04 * L);
      g.quadraticCurveTo(cx - 0.4 * L + shift * 0.5, cy - 0.07 * L, cx - 0.5 * L + shift, cy - tail * L * open);
      g.quadraticCurveTo(cx - 0.41 * L + shift * 0.6, cy - 0.04 * L, cx - 0.42 * L + shift * 0.5, cy);
      g.quadraticCurveTo(cx - 0.41 * L + shift * 0.6, cy + 0.04 * L, cx - 0.5 * L + shift, cy + tail * L * open);
      g.quadraticCurveTo(cx - 0.4 * L + shift * 0.5, cy + 0.07 * L, cx - 0.33 * L, cy + 0.04 * L);
      g.bezierCurveTo(cx - 0.04 * L, cy + deep * L * 0.95, cx + 0.36 * L, cy + deep * L * 0.9, cx + 0.5 * L, cy + 0.5);
      g.closePath();
    };
    const drawFishSprite = (g, ph, o, flash) => {
      const L = 56, cx = 32, cy = 16, deep = o.deep;
      fishPath(g, ph, o);
      const grad = g.createLinearGradient(0, cy - deep * L, 0, cy + deep * L);
      if (flash) {
        grad.addColorStop(0, 'rgba(255,255,255,0)');
        grad.addColorStop(0.3, 'rgba(255,252,244,0.75)');
        grad.addColorStop(0.55, 'rgba(255,255,255,1)');
        grad.addColorStop(0.8, 'rgba(255,252,244,0.6)');
        grad.addColorStop(1, 'rgba(255,255,255,0)');
        g.fillStyle = grad;
        g.fill();
        return;
      }
      const p = o.pal;
      grad.addColorStop(0, rgb(p.back));
      grad.addColorStop(0.4, rgb(p.steel));
      grad.addColorStop(0.53, rgb(p.silver));
      grad.addColorStop(0.62, rgb(p.bright));
      grad.addColorStop(0.84, rgb(p.belly));
      grad.addColorStop(1, rgb(toward(p.belly, p.back, 0.35)));
      g.fillStyle = grad;
      g.fill();
      g.save();
      fishPath(g, ph, o);
      g.clip();
      g.fillStyle = rgba(p.back, 0.32);
      g.fillRect(0, 0, cx - 0.33 * L, 32);
      if (o.stripe) {
        g.strokeStyle = rgba(o.stripe, 0.62);
        g.lineWidth = 1.3;
        g.beginPath();
        g.moveTo(cx + 0.28 * L, cy - 0.035 * L);
        g.quadraticCurveTo(cx, cy - 0.05 * L, cx - 0.34 * L, cy - 0.01 * L);
        g.stroke();
      }
      g.strokeStyle = rgba(p.back, 0.4);
      g.lineWidth = 0.8;
      g.beginPath();
      g.arc(cx + 0.36 * L, cy, 0.1 * L, Math.PI - 0.95, Math.PI + 0.95);
      g.stroke();
      if (o.spot) { g.fillStyle = rgba(p.back, 0.6); g.beginPath(); g.arc(cx + 0.2 * L, cy - 0.05 * L, 0.03 * L, 0, Math.PI * 2); g.fill(); }
      g.restore();
      g.fillStyle = rgba(p.back, 0.85);
      g.beginPath();
      g.moveTo(cx + 0.05 * L, cy - deep * L * 0.97);
      g.quadraticCurveTo(cx - 0.05 * L, cy - deep * L - o.fin * L, cx - 0.14 * L, cy - deep * L * 0.86);
      g.closePath();
      g.fill();
      g.fillStyle = rgba(p.silver, 0.45);
      g.beginPath();
      g.moveTo(cx + 0.25 * L, cy + 0.04 * L);
      g.quadraticCurveTo(cx + 0.16 * L, cy + 0.11 * L, cx + 0.12 * L, cy + 0.1 * L);
      g.quadraticCurveTo(cx + 0.17 * L, cy + 0.05 * L, cx + 0.25 * L, cy + 0.04 * L);
      g.fill();
      const er = o.eye * L;
      g.fillStyle = 'rgb(8 12 24)';
      g.beginPath(); g.arc(cx + 0.385 * L, cy - 0.025 * L, er, 0, Math.PI * 2); g.fill();
      g.strokeStyle = rgba(p.silver, 0.7);
      g.lineWidth = 0.6;
      g.stroke();
      g.fillStyle = 'rgba(255,255,255,0.85)';
      g.beginPath(); g.arc(cx + 0.392 * L, cy - 0.035 * L, er * 0.32, 0, Math.PI * 2); g.fill();
    };
    const palette = (d, base) => {
      const water = seaAt(d);
      const m = (c, k) => toward(c, water, k);
      return { back: m(base.back, 0.22 + d * 0.3), steel: m(base.steel, 0.2 + d * 0.35), silver: m(base.silver, 0.12 + d * 0.4), bright: m(base.bright, 0.06 + d * 0.42), belly: m(base.belly, 0.1 + d * 0.42) };
    };
    const SPECIES = {
      bait: { deep: 0.15, tail: 0.19, fin: 0.06, eye: 0.042, base: { back: [16, 32, 66], steel: [64, 102, 152], silver: [164, 184, 204], bright: [236, 238, 234], belly: [210, 218, 224] }, stripe: [56, 140, 204] },
      jack: { deep: 0.21, tail: 0.24, fin: 0.09, eye: 0.028, spot: true, base: { back: [26, 44, 80], steel: [96, 126, 160], silver: [176, 190, 202], bright: [226, 228, 224], belly: [206, 210, 212] } },
      lantern: { deep: 0.15, tail: 0.17, fin: 0.05, eye: 0.075, base: { back: [22, 32, 56], steel: [40, 56, 90], silver: [62, 82, 120], bright: [84, 106, 146], belly: [66, 86, 124] } }
    };
    const atlasCache = new Map();
    const atlas = (kind, tone, unitPx) => {
      const key = kind + tone + unitPx;
      if (atlasCache.has(key)) return atlasCache.get(key);
      const sp = SPECIES[kind];
      const o = { ...sp, pal: palette(tone, sp.base) };
      const cw = 64 * unitPx, ch = 32 * unitPx;
      const c = document.createElement('canvas');
      c.width = Math.ceil(cw * FRAMES);
      c.height = Math.ceil(ch * 2);
      const g = c.getContext('2d');
      for (let f = 0; f < FRAMES; f++) {
        const ph = f / FRAMES * Math.PI * 2;
        for (let row = 0; row < 2; row++) {
          g.setTransform(unitPx, 0, 0, unitPx, f * cw, row * ch);
          drawFishSprite(g, ph, o, row === 1);
        }
      }
      const a = { c, cw, ch };
      atlasCache.set(key, a);
      return a;
    };
    const glow = (() => {
      const c = document.createElement('canvas');
      c.width = c.height = 64;
      const g = c.getContext('2d');
      const r = g.createRadialGradient(32, 32, 0, 32, 32, 32);
      r.addColorStop(0, 'rgba(120,230,255,1)');
      r.addColorStop(0.25, 'rgba(0,169,206,0.55)');
      r.addColorStop(1, 'rgba(0,169,206,0)');
      g.fillStyle = r;
      g.fillRect(0, 0, 64, 64);
      return c;
    })();

    /* ---------- What lives in each band ---------- */
    const tone = d => d < 0.3 ? 0.15 : d < 0.6 ? 0.45 : 0.75;
    // A school travels a wide sine across the band and turns at the ends; each fish follows the
    // same path a little late, so a turn ripples through the school instead of happening at once.
    const school = (seed, o) => {
      const members = [];
      for (let i = 0; i < o.n; i++) {
        const a = hash(seed + i * 1.37), b = hash(seed + i * 2.71), c = hash(seed + i * 4.13);
        const r = Math.sqrt(hash(seed + i * 5.9));
        const ang = a * Math.PI * 2;
        members.push({ ox: Math.cos(ang) * r, oy: Math.sin(ang) * r * 0.85 + (b - 0.5) * 0.2, oz: c, lag: c * 0.55 + b * 0.3, ph: a * 50, w: 7 + b * 3.5, sz: 0.84 + hash(seed + i * 7.7) * 0.32, rr: 0.45 + 0.55 * Math.sqrt(b), a0: a * Math.PI * 2, yy: (c - 0.5) * 2, sp: hash(seed + i * 8.9) });
      }
      members.sort((p, q) => q.oz - p.oz);
      const vmax = W * (o.amp || 0) * Math.PI * 2 / (o.period || 1);
      return { ...o, seed, members, vmax };
    };
    let ballPlaced = false;
    const populate = k => {
      const y0 = k * BAND, y1 = Math.min(SH, y0 + BAND), h = y1 - y0;
      const d = (y0 + h / 2) / SH;
      const big = W >= 990;
      const r = i => hash(k * 17.31 + i * 3.71 + 0.5);
      const top = k === 0 ? 190 : 80;
      const yAt = i => top + r(i) * Math.max(10, h - top - 90);
      const out = { schools: [], jellies: [], snow: [], d, h };
      const add = (i, kind, o) => out.schools.push(school(k * 101 + i * 13, { kind, tone: tone(d), y: yAt(i), cx: 0.5 + (r(i + 9) - 0.5) * 0.3, phase: r(i + 3) * 6.28, dy: 10 + r(i + 4) * 20, ...o }));
      const bait = (i, near) => {
        const L = near ? (big ? 34 : 26) + r(i + 21) * (big ? 8 : 6) : (big ? 17 : 14) + r(i + 21) * 3;
        add(i, 'bait', { n: near ? Math.round((big ? 30 : 20) + r(i + 20) * (big ? 18 : 12)) : Math.round((big ? 30 : 22) + r(i + 20) * 12), L, sx: L * (near ? 3.4 : 5) + r(i + 22) * L, sy: L * (near ? 1.35 : 1.8), amp: (near ? 0.36 : 0.55) + r(i + 24) * 0.28, period: (near ? 26 : 38) + r(i + 25) * 18, alpha: near ? 0.92 : 0.4, lagScale: near ? 1.3 : 1.7, haze: !near });
      };
      if (d > 0.93) return out;
      if (d < 0.64) {
        // A bait ball: the school mills in a ring, fish flashing as they turn toward you
        if (!ballPlaced && d > 0.16) {
          ballPlaced = true;
          const R = big ? 150 : 82;
          out.schools.push(school(k * 101 + 77, { kind: 'bait', ball: true, tone: tone(d), n: big ? 90 : 56, L: big ? 26 : 19, R, y: Math.max(top + R * 0.6, Math.min(h - R * 0.7, h * 0.5)), cx: big ? 0.72 : 0.62, omega: 0.42, dir: 1, alpha: 0.92 }));
        }
        bait(0, true);
        if (r(30) > 0.45) bait(1, true);
        bait(5, false);
        if (d > 0.2 && r(50) > 0.4) add(6, 'jack', { n: 1, L: (big ? 96 : 68) + r(51) * 18, sx: 0, sy: 0, amp: 0.62, period: 50 + r(52) * 20, alpha: 0.9, lagScale: 0 });
      } else {
        add(7, 'lantern', { n: 4 + Math.round(r(60) * 4), L: (big ? 34 : 27) + r(61) * 5, sx: big ? 130 : 80, sy: 50, amp: 0.3 + r(62) * 0.25, period: 40 + r(63) * 20, alpha: 1, lagScale: 2.2 });
        if (r(64) > 0.4) bait(8, false);
        if (r(66) > 0.3) out.jellies.push({ x: 0.18 + r(67) * 0.64, y: yAt(68), r: (big ? 26 : 19) + r(69) * 8, ph: r(70) * 6.28, drift: 10 + r(71) * 14 });
      }
      if (d > 0.42 && d < 0.64 && r(80) > 0.55) out.jellies.push({ x: 0.18 + r(81) * 0.64, y: yAt(82), r: (big ? 22 : 16) + r(83) * 6, ph: r(84) * 6.28, drift: 12 });
      const nSnow = big ? 34 : 22;
      for (let i = 0; i < nSnow; i++) out.snow.push({ x: hash(k * 9.1 + i * 1.3), y: hash(k * 5.3 + i * 2.7), s: 0.8 + hash(k + i * 5.1) * 1.4, v: 5 + hash(k * 2 + i * 9.2) * 9 });
      return out;
    };

    /* ---------- Drawing ---------- */
    const unitFor = L => Math.max(0.5, Math.min(3, Math.round((L * DPR / 56) * 4) / 4));
    const P2 = Math.PI * 2;
    const blit = (g, A, s, t, m, x, y, vx, vy, vref, L, alpha, lantern) => {
      let face = vref ? Math.max(-1, Math.min(1, vx / (vref * 0.3))) : 1;
      if (Math.abs(face) < 0.1) face = face < 0 ? -0.1 : 0.1;
      const sign = face < 0 ? -1 : 1;
      const tilt = sign * Math.atan2(vy, Math.abs(vx) + 1) * 0.8;
      const speed = vref ? Math.min(1, Math.hypot(vx, vy) / vref) : 0.5;
      const beat = ((t * m.w * (0.55 + 0.6 * speed) + m.ph) / P2) % 1;
      const f = Math.floor(beat * FRAMES) % FRAMES;
      const k = L / 56, cos = Math.cos(tilt), sin = Math.sin(tilt);
      g.setTransform(DPR * cos * face * k, DPR * sin * face * k, -DPR * sin * k, DPR * cos * k, DPR * x, DPR * (y + PAD));
      g.globalAlpha = alpha;
      g.drawImage(A.c, f * A.cw, 0, A.cw, A.ch, -32, -16, 64, 32);
      if (!lantern) {
        const flash = Math.pow(1 - Math.abs(face), 2) * 0.9 + 0.45 * Math.pow(Math.max(0, Math.sin(t * 1.7 + m.ph * 3)), 14);
        if (flash > 0.03) { g.globalAlpha = alpha * Math.min(1, flash) * (s.haze ? 0.5 : 1); g.drawImage(A.c, f * A.cw, A.ch, A.cw, A.ch, -32, -16, 64, 32); }
      } else {
        g.globalCompositeOperation = 'lighter';
        for (let j = 0; j < 6; j++) {
          g.globalAlpha = (0.6 + 0.4 * Math.sin(t * 2.4 + m.ph + j * 0.9)) * alpha;
          g.drawImage(glow, 26 - j * 6 - 4.5, 21 - 4.5 + j * 0.25, 9, 9);
        }
        g.globalAlpha = 0.8 * alpha;
        g.drawImage(glow, 49, 9, 11, 11);
        g.globalCompositeOperation = 'source-over';
      }
    };
    const drawSchool = (g, s, t) => {
      const lantern = s.kind === 'lantern';
      const A = atlas(s.kind, s.tone, unitFor(s.L * 1.2));
      if (s.ball) {
        const list = [];
        const drift = 18 * Math.sin(t * 0.07 + s.seed);
        for (const m of s.members) {
          const w = s.omega * (0.85 + 0.3 * m.sp);
          const th = m.a0 + s.dir * w * t;
          const r = s.R * m.rr;
          const z = Math.sin(th);
          list.push({ m, z, x: W * s.cx + drift + r * Math.cos(th), y: s.y + r * 0.38 * z + m.yy * s.R * 0.32 + 3 * Math.sin(t * 1.3 + m.ph), vx: -r * w * Math.sin(th) * s.dir, vy: r * 0.38 * w * Math.cos(th) * s.dir, vref: r * w });
        }
        list.sort((a, b) => a.z - b.z);
        for (const p of list) blit(g, A, s, t, p.m, p.x, p.y, p.vx, p.vy, p.vref, s.L * p.m.sz * (1 + 0.2 * p.z), s.alpha * (0.62 + 0.38 * (p.z * 0.5 + 0.5)), false);
        g.globalAlpha = 1;
        return;
      }
      for (const m of s.members) {
        const tm = t - m.lag * s.lagScale;
        const ang = P2 * tm / s.period + s.phase;
        const vx = s.vmax * Math.cos(ang);
        const ang2 = P2 * tm / (s.period * 0.7) + s.phase * 1.3;
        const vy = s.dy * (P2 / (s.period * 0.7)) * Math.cos(ang2);
        const breathe = 1 + 0.12 * Math.sin(t * 0.35 + s.phase);
        const x = W * (s.cx + s.amp * Math.sin(ang)) + m.ox * s.sx * breathe + 4 * Math.sin(t * 0.9 + m.ph);
        const y = s.y + s.dy * Math.sin(ang2) + m.oy * s.sy * breathe + 3 * Math.sin(t * 1.25 + m.ph * 1.3);
        if (x < -80 || x > W + 80) continue;
        blit(g, A, s, t, m, x, y, vx, vy, s.vmax, s.L * m.sz * (1 - 0.25 * m.oz), s.alpha * (1 - 0.35 * m.oz), lantern);
      }
      g.globalAlpha = 1;
    };
    const drawJelly = (g, j, t) => {
      const c = 0.5 + 0.5 * Math.sin(t * 2.2 + j.ph);
      const x = W * j.x + j.drift * Math.sin(t * 0.11 + j.ph);
      const y = j.y + 14 * Math.sin(t * 0.17 + j.ph) - 5 * c;
      const bw = j.r * (1 - 0.12 * c), bh = j.r * 0.82 * (1 + 0.12 * c);
      g.setTransform(DPR, 0, 0, DPR, DPR * x, DPR * (y + PAD));
      g.globalCompositeOperation = 'lighter';
      g.globalAlpha = 0.14 + 0.06 * c;
      g.drawImage(glow, -j.r * 2.2, -j.r * 2.4, j.r * 4.4, j.r * 4.4);
      g.globalCompositeOperation = 'source-over';
      g.globalAlpha = 1;
      g.lineCap = 'round';
      for (let i = 0; i < 9; i++) {
        const sx = -bw * 0.85 + (bw * 1.7) * (i / 8);
        const len = j.r * (2.4 + hash(i + j.ph) * 1.4);
        g.beginPath();
        g.moveTo(sx, 1);
        for (let s = 1; s <= 12; s++) {
          const u = s / 12;
          g.lineTo(sx * (1 - u * 0.25) + Math.sin(t * 1.5 + s * 0.55 + i * 1.7 + j.ph) * u * 7, u * len + c * 4 * u);
        }
        g.strokeStyle = 'rgba(253,245,228,' + (0.14 + 0.06 * (i % 2)) + ')';
        g.lineWidth = 0.8;
        g.stroke();
      }
      for (let i = 0; i < 2; i++) {
        g.beginPath();
        g.moveTo((i - 0.5) * bw * 0.4, 0);
        for (let s = 1; s <= 10; s++) {
          const u = s / 10;
          g.lineTo((i - 0.5) * bw * 0.4 + Math.sin(t * 1.1 + s * 0.7 + i * 2 + j.ph) * u * 6, u * j.r * 1.9);
        }
        g.strokeStyle = 'rgba(253,245,228,0.22)';
        g.lineWidth = 2.6;
        g.stroke();
      }
      g.beginPath();
      g.moveTo(-bw, 0);
      g.bezierCurveTo(-bw, -bh * 1.32, bw, -bh * 1.32, bw, 0);
      const sc = 7;
      for (let i = 0; i < sc; i++) {
        const xa = bw - (2 * bw) * (i / sc), xb = bw - (2 * bw) * ((i + 1) / sc);
        g.quadraticCurveTo((xa + xb) / 2, 3.5 + 1.5 * c, xb, 0);
      }
      const rg = g.createRadialGradient(0, -bh * 0.7, 1, 0, -bh * 0.3, bw * 1.2);
      rg.addColorStop(0, 'rgba(253,245,228,0.34)');
      rg.addColorStop(0.6, 'rgba(160,220,240,0.14)');
      rg.addColorStop(1, 'rgba(0,169,206,0.06)');
      g.fillStyle = rg;
      g.fill();
      g.strokeStyle = 'rgba(120,225,250,0.5)';
      g.lineWidth = 1.1;
      g.stroke();
      g.strokeStyle = 'rgba(253,245,228,0.22)';
      g.lineWidth = 1;
      for (let i = 0; i < 4; i++) { g.beginPath(); g.ellipse((i - 1.5) * bw * 0.28, -bh * 0.42, bw * 0.13, bh * 0.16, 0, 0, Math.PI * 2); g.stroke(); }
    };
    const drawSnow = (g, b, t) => {
      const a = 0.06 + 0.32 * b.d;
      g.setTransform(DPR, 0, 0, DPR, 0, DPR * PAD);
      g.fillStyle = 'rgba(253,245,228,' + a.toFixed(3) + ')';
      const h = b.h + 40;
      for (let i = 0; i < b.snow.length; i++) {
        const p = b.snow[i];
        const x = p.x * W + Math.sin(t * 0.3 + i) * 6;
        const y = ((((p.y * h + t * p.v) % h) + h) % h) - 20;
        g.fillRect(x, y, p.s, p.s);
      }
    };
    const drawBand = (b, t) => {
      const g = b.ctx;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.clearRect(0, 0, b.cv.width, b.cv.height);
      drawSnow(g, b.life, t);
      const L = b.life;
      for (const s of L.schools) if (s.haze) drawSchool(g, s, t);
      for (const j of L.jellies) drawJelly(g, j, t);
      for (const s of L.schools) if (!s.haze) drawSchool(g, s, t);
      g.setTransform(1, 0, 0, 1, 0, 0);
    };

    /* ---------- Bands come and go with the viewport ---------- */
    const activate = b => {
      if (b.cv) return;
      const cv = document.createElement('canvas');
      cv.className = 'band';
      cv.style.top = (b.y0 - PAD) + 'px';
      cv.style.height = (b.h + PAD * 2) + 'px';
      cv.width = Math.round(W * DPR);
      cv.height = Math.round((b.h + PAD * 2) * DPR);
      seaBg.appendChild(cv);
      b.cv = cv;
      b.ctx = cv.getContext('2d');
      if (!b.life) b.life = populate(b.k);
      drawBand(b, reduce.matches ? 6 : performance.now() / 1000);
    };
    const deactivate = b => {
      if (!b.cv) return;
      b.cv.width = b.cv.height = 0;
      b.cv.remove();
      b.cv = b.ctx = null;
    };
    const updateBands = () => {
      if (!sea) return;
      const top = scrollY - seaTop - 250, bottom = scrollY - seaTop + innerHeight + 250;
      let any = false;
      for (const b of bands) {
        const isOn = b.y0 + b.h > top && b.y0 < bottom;
        if (isOn) { activate(b); any = true; } else deactivate(b);
      }
      if (any) kick();
    };

    /* ---------- Caustics in the first screen of water ---------- */
    const caustCv = sea ? $('#caustics', sea) : null;
    const gl = caustCv ? caustCv.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, powerPreference: 'low-power' }) : null;
    let caust = null, caustVisible = false;
    if (gl) {
      const VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
      const FS = 'precision mediump float;uniform float u_s,u_t,u_h,u_len;void main(){vec2 sp=vec2(gl_FragCoord.x,u_h-gl_FragCoord.y)/u_s;vec2 p=mod(sp*(6.2831853/380.0),6.2831853)-250.0;vec2 i=p;float c=1.0;float inten=0.005;float t=u_t*0.32+23.0;for(int n=0;n<5;n++){float tn=t*(1.0-(3.5/float(n+1)));i=p+vec2(cos(tn-i.x)+sin(tn+i.y),sin(tn-i.y)+cos(tn+i.x));c+=1.0/length(vec2(p.x/(sin(i.x+tn)/inten),p.y/(cos(i.y+tn)/inten)));}c/=5.0;c=1.17-pow(c,1.4);float v=clamp(pow(abs(c),8.0),0.0,1.0);float fade=smoothstep(4.0,60.0,sp.y)*(1.0-smoothstep(u_len*0.12,u_len,sp.y));float a=v*0.22*fade;vec3 col=mix(vec3(0.0,0.66,0.81),vec3(1.0,0.99,0.95),clamp(v*1.4,0.0,1.0));gl_FragColor=vec4(col*a,a);}';
      const make = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; };
      const prog = gl.createProgram();
      gl.attachShader(prog, make(gl.VERTEX_SHADER, VS));
      gl.attachShader(prog, make(gl.FRAGMENT_SHADER, FS));
      gl.linkProgram(prog);
      if (gl.getProgramParameter(prog, gl.LINK_STATUS)) {
        gl.useProgram(prog);
        gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        const loc = gl.getAttribLocation(prog, 'p');
        gl.enableVertexAttribArray(loc);
        gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
        const u = n => gl.getUniformLocation(prog, n);
        caust = { s: u('u_s'), t: u('u_t'), h: u('u_h'), len: u('u_len'), scale: 1, len0: 900 };
      }
    }
    if (caustCv && !caust) caustCv.style.display = 'none';
    const sizeCaustics = () => {
      if (!caust) return;
      caust.len0 = Math.min(1100, Math.max(720, innerHeight * 1.15));
      caust.scale = Math.min(DPR, 2) * 0.5;
      caustCv.style.height = caust.len0 + 'px';
      caustCv.width = Math.max(1, Math.round(W * caust.scale));
      caustCv.height = Math.max(1, Math.round(caust.len0 * caust.scale));
      gl.viewport(0, 0, caustCv.width, caustCv.height);
    };
    const drawCaustics = t => {
      gl.uniform1f(caust.s, caust.scale);
      gl.uniform1f(caust.t, t);
      gl.uniform1f(caust.h, caustCv.height);
      gl.uniform1f(caust.len, caust.len0);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    };
    if (caust) watch(new IntersectionObserver(([e]) => { caustVisible = e.isIntersecting; if (caustVisible) kick(); })).observe(caustCv);

    /* ---------- One animation loop, by time only ---------- */
    function frame(now) {
      raf = 0;
      const t = reduce.matches ? 6 : now / 1000;
      let busy = false;
      for (const b of bands) if (b.cv) { drawBand(b, t); busy = true; }
      if (caust && caustVisible) { drawCaustics(t); busy = true; }
      if (busy && !reduce.matches && !document.hidden) raf = requestAnimationFrame(frame);
    }
    on(document, 'visibilitychange', () => { if (!document.hidden) kick(); });

    const layoutSea = () => {
      if (!sea) return;
      W = sea.clientWidth;
      SH = sea.offsetHeight;
      seaTop = pageY(sea);
      bands.forEach(deactivate);
      $$('.rock, .fleck', seaBg).forEach(n => n.remove());
      atlasCache.clear();
      ballPlaced = false;
      const n = Math.ceil(SH / BAND);
      bands = [];
      let html = '';
      for (let k = 0; k < n; k++) {
        const y0 = k * BAND;
        bands.push({ k, y0, h: Math.min(SH, y0 + BAND) - y0, cv: null, ctx: null, life: null });
        html += rockSVG(k, 'far') + rockSVG(k, 'near') + flecksFor(k);
      }
      seaBg.insertAdjacentHTML('beforeend', html);
      sizeCaustics();
      updateBands();
    };

    /* ---------- Bubbles ---------- */
    const bubbleHost = $('#bubbles'), bubbleFixed = $('#bubblesFixed');
    const bubble = (host, x, y, rise, dur) => {
      if (!host) return;
      const b = document.createElement('i');
      const s = 3 + Math.random() * 7;
      b.className = 'bub';
      b.style.cssText = 'left:' + x.toFixed(1) + 'px;top:' + y.toFixed(1) + 'px;width:' + s.toFixed(1) + 'px;height:' + s.toFixed(1) + 'px;--dx:' + ((Math.random() - 0.5) * 30).toFixed(1) + 'px;--dy:' + (-rise).toFixed(0) + 'px;--dur:' + dur.toFixed(2) + 's;animation-delay:' + (Math.random() * 0.25).toFixed(2) + 's';
      b.addEventListener('animationend', () => b.remove(), { once: true });
      host.appendChild(b);
    };
    const puff = (el, n = 12) => {
      if (reduce.matches || !sea) return;
      const r = el.getBoundingClientRect(), s = sea.getBoundingClientRect();
      for (let i = 0; i < n; i++) bubble(bubbleHost, r.left - s.left + 12 + Math.random() * 46, r.bottom - s.top - 6, 70 + Math.random() * 90, 1.3 + Math.random() * 1.1);
    };

    /* ---------- Depth gauge ---------- */
    const MAX_DEPTH = 1200;
    const gauge = $('#gauge');
    const marks = $('#gaugeMarks');
    const stops = $$('[data-stop]').map(el => ({ el, name: el.dataset.stop, at: 0 }));
    const ZONES = [[0, 'At the surface'], [1, 'Sunlight zone'], [200, 'Twilight zone'], [1000, 'Midnight zone']];
    const FACTS = [
      { m: 200, text: 'Twilight zone. Most sunlight is gone by about 200 m.', shown: false },
      { m: 1000, text: 'Midnight zone. Below about 1,000 m, no sunlight reaches at all.', shown: false }
    ];
    const depthOf = () => clamp01((scrollY + innerHeight * 0.5 - seaTop) / Math.max(1, SH - innerHeight * 0.5));
    const buildMarks = () => {
      if (!marks || !sea) return;
      marks.innerHTML = '';
      for (let m = 100; m < MAX_DEPTH; m += 100) { const i = document.createElement('i'); i.className = 'gauge__tick'; i.style.top = (m / MAX_DEPTH * 100) + '%'; marks.appendChild(i); }
      stops.forEach(s => {
        s.at = clamp01((pageY(s.el) - seaTop) / Math.max(1, SH - innerHeight * 0.5));
        const i = document.createElement('i'); i.className = 'gauge__stop'; i.style.top = (s.at * 100) + '%'; marks.appendChild(i);
      });
    };
    let shownDepth = -1, shownZone = '', shownStop = '', talkTimer = 0, toastTimer = 0, inWater = null;
    const say = name => { $('#gaugeLabel').textContent = name; gauge.classList.add('is-talking'); clearTimeout(talkTimer); talkTimer = setTimeout(() => gauge.classList.remove('is-talking'), 2200); timers.add(talkTimer); };
    const toast = text => {
      const roomy = innerWidth >= 1280;
      const el = roomy ? $('#gaugeFact') : $('#depthBanner');
      if (!el) return;
      (roomy ? $('span', el) : el).textContent = text;
      el.classList.add('is-shown');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => el.classList.remove('is-shown'), 3200);
      timers.add(toastTimer);
    };
    const updateGauge = () => {
      if (!gauge || !sea) return;
      const wet = scrollY + innerHeight * 0.6 > seaTop;
      if (wet !== inWater) { inWater = wet; gauge.classList.toggle('is-in', wet); $('#hdrDepthWrap')?.classList.toggle('is-on', wet); }
      const p = depthOf();
      gauge.style.setProperty('--p', p.toFixed(4));
      const depth = scrollY + innerHeight * 0.5 < seaTop ? 0 : Math.round(p * MAX_DEPTH / 5) * 5;
      if (depth !== shownDepth) {
        const m = depth.toLocaleString('en-US') + ' m';
        $('#depthNum').textContent = m;
        const hd = $('#hdrDepth');
        if (hd) hd.textContent = m;
        const zone = ZONES.filter(z => depth >= z[0]).pop()[1];
        if (zone !== shownZone) { $('#depthZone').textContent = zone; const hz = $('#hdrZone'); if (hz) hz.textContent = zone; shownZone = zone; }
        if (depth > shownDepth) FACTS.forEach(f => { if (!f.shown && depth >= f.m && shownDepth >= 0 && shownDepth < f.m) { f.shown = true; toast(f.text); } });
        shownDepth = depth;
      }
      let current = '';
      stops.forEach(s => { if (p >= s.at - 0.002) current = s.name; });
      if (current && current !== shownStop) { if (shownStop) say(current); shownStop = current; }
    };

    /* ---------- Arrival: titles rise in as you reach each section ---------- */
    const arrived = new WeakSet();
    const arriveIO = watch(new IntersectionObserver(entries => entries.forEach(e => {
      const el = e.target;
      if (!e.isIntersecting || arrived.has(el)) return;
      arrived.add(el);
      if (reduce.matches || e.boundingClientRect.top < innerHeight * 0.25) return;
      el.classList.add('is-arriving');
      puff(el, 12);
      el.addEventListener('animationend', () => el.classList.remove('is-arriving'), { once: true });
    }), { threshold: 0.35 }));
    $$('[data-arrive]').forEach(el => arriveIO.observe(el));

    /* ---------- Surfacing: the button on the floor carries you back up ---------- */
    const surface = trigger => {
      const start = scrollY;
      if (reduce.matches || start < 40) { scrollTo(0, 0); addToCart(atcBtn, true); return; }
      const docEl = document.documentElement;
      docEl.style.scrollBehavior = 'auto';
      const dur = Math.min(2400, 1000 + start * 0.12);
      const t0 = performance.now();
      const ease = k => k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      const stop = () => { cancelAnimationFrame(surfacing); surfacing = 0; docEl.style.scrollBehavior = ''; removeEventListener('wheel', stop); removeEventListener('touchstart', stop); };
      addEventListener('wheel', stop, { passive: true });
      addEventListener('touchstart', stop, { passive: true });
      const r = trigger.getBoundingClientRect();
      for (let i = 0; i < 18; i++) bubble(bubbleFixed, r.left + r.width / 2 + (Math.random() - 0.5) * 60, r.top, innerHeight * (0.5 + Math.random() * 0.4), 1.6 + Math.random());
      const step = now => {
        const k = Math.min(1, (now - t0) / dur);
        scrollTo(0, start * (1 - ease(k)));
        if (Math.random() < 0.55) bubble(bubbleFixed, innerWidth * (0.15 + Math.random() * 0.7), innerHeight + 10, innerHeight * (0.6 + Math.random() * 0.5), 1.4 + Math.random() * 0.8);
        if (k < 1) surfacing = requestAnimationFrame(step);
        else { stop(); addToCart(atcBtn, true); }
      };
      surfacing = requestAnimationFrame(step);
    };
    on($('#closerAdd'), 'click', e => surface(e.currentTarget));

    /* ---------- Scroll: only the sticky bar, gauge and band bookkeeping, once per frame ---------- */
    let scrollQueued = false;
    on(window, 'scroll', () => {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(() => { scrollQueued = false; updateSticky(); updateGauge(); updateBands(); });
    }, { passive: true });

    /* ---------- Layout: rebuild the sea only when its size really changes ---------- */
    let lastW = -1, lastH = -1, relayoutTimer = 0;
    const relayout = () => {
      if (!sea) return;
      const w = sea.clientWidth, h = sea.offsetHeight;
      if (w === lastW && Math.abs(h - lastH) < 4) { seaTop = pageY(sea); buildMarks(); updateGauge(); return; }
      lastW = w; lastH = h;
      layoutSea();
      buildMarks();
      updateGauge();
    };
    if (sea) {
      watch(new ResizeObserver(() => { clearTimeout(relayoutTimer); relayoutTimer = setTimeout(relayout, 120); timers.add(relayoutTimer); })).observe(sea);
      on(window, 'load', relayout);
      relayout();
    }

    return () => {
      ac.abort();
      observers.forEach(o => o.disconnect());
      timers.forEach(t => clearTimeout(t));
      cancelAnimationFrame(raf);
      cancelAnimationFrame(surfacing);
      bands.forEach(deactivate);
      if (seaBg) $$('.rock, .fleck', seaBg).forEach(n => n.remove());
      document.body.style.overflow = '';
    };
  }

  let teardown = init();
  // Theme editor: sections re-render in place, so start over cleanly after each change.
  if (window.Shopify && window.Shopify.designMode) {
    let t = 0;
    const restart = () => { clearTimeout(t); t = setTimeout(() => { teardown(); teardown = init(); }, 60); };
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(type => document.addEventListener(type, restart));
  }
})();
